<!--支付开户(已保存未提交)-->
<template>
  <div v-loading="loading">
    <div class="module">
      <h5 class="module-title">公司基本信息</h5>
      <div class="module-descriptions">
        <div class="descriptions-item">
          <span class="label text-number-7">公司名称：</span>
          <span class="value">
            <span>{{ detailsData?.companyName }}</span>
          </span>
        </div>
        <div class="descriptions-item">
          <span class="label text-number-14">公司注册地：</span>
          <span class="value">
            <span
              >{{ detailsData?.province }}{{ detailsData?.city
              }}{{ detailsData?.district }}</span
            >
          </span>
        </div>
        <div class="descriptions-item">
          <span class="label text-number-7">注册地址：</span>
          <span class="value">
            <span>{{ detailsData?.regCity }}</span>
          </span>
        </div>
        <div class="descriptions-item">
          <span class="label text-number-14">营业执照号：</span>
          <span class="value">
            <span>{{ getAttachmentInfo('MRC')?.certificateNo }}</span>
            <el-button type="text" size="small" @click="previewFile('MRC')"
              >预览</el-button
            >
          </span>
        </div>
        <div class="descriptions-item">
          <span class="label">营业执照有效期：</span>
          <span class="value">
            <span>{{
              getAttachmentInfo('MRC')?.certificateLongValid === 1
                ? '长期有效'
                : getAttachmentInfo('MRC')?.certificateEndTime
            }}</span>
          </span>
        </div>
      </div>
    </div>
    <div class="module">
      <h5 class="module-title">申请人信息</h5>
      <div class="module-tips">申请人只能为易派客管理员，请补充相关信息</div>
      <div class="module-descriptions">
        <div class="descriptions-item">
          <span class="label text-number-5">申请人：</span>
          <span class="value">
            <span>{{ detailsData?.creatorRealName }}</span>
          </span>
        </div>
        <div class="descriptions-item">
          <span class="label text-number-14">证件类型：</span>
          <span class="value">
            <span>{{
              getCertificateTypeDesc(getAttachmentInfo('AC')?.certificateType)
            }}</span>
          </span>
        </div>
        <div class="descriptions-item">
          <span class="label text-number-5">证件号码：</span>
          <span class="value">
            <span>{{ getAttachmentInfo('AC')?.certificateNo }}</span>
          </span>
        </div>
        <div class="descriptions-item">
          <span class="label text-number-14">证件有效期：</span>
          <span class="value">
            <span>{{
              getAttachmentInfo('AC')?.certificateLongValid === 1
                ? '长期有效'
                : getAttachmentInfo('AC')?.certificateEndTime
            }}</span>
          </span>
        </div>
        <div class="descriptions-item">
          <span class="label">证件复印件：</span>
          <span class="value">
            <el-button type="text" size="small" @click="previewFile('AC')"
              >预览</el-button
            >
          </span>
        </div>
        <div class="descriptions-item">
          <span class="label text-number-14">授权书：</span>
          <span class="value">
            <el-button type="text" size="small" @click="previewFile('AA')"
              >预览</el-button
            >
          </span>
        </div>
      </div>
    </div>
    <div class="module">
      <h5 class="module-title">公司法定代表人信息</h5>
      <div class="module-descriptions">
        <div class="descriptions-item">
          <span class="label">法定代表人名称：</span>
          <span class="value">
            <span>{{ detailsData?.legalPerson }}</span>
          </span>
        </div>
        <div class="descriptions-item">
          <span class="label text-number-14">手机号码：</span>
          <span class="value">
            <span>{{ detailsData?.legalPersonMobile }}</span>
          </span>
        </div>
        <div class="descriptions-item">
          <span class="label text-number-7">证件类型：</span>
          <span class="value">
            <span>{{
              getCertificateTypeDesc(getAttachmentInfo('LRC')?.certificateType)
            }}</span>
          </span>
        </div>
        <div class="descriptions-item">
          <span class="label text-number-14">证件号码：</span>
          <span class="value">
            <span>{{ getAttachmentInfo('LRC')?.certificateNo }}</span>
            <el-button type="text" size="small" @click="previewFile('LRC')"
              >预览</el-button
            >
          </span>
        </div>
        <div class="descriptions-item">
          <span class="label text-number-7">证件有效期：</span>
          <span class="value">
            <span>{{
              getAttachmentInfo('LRC')?.certificateLongValid === 1
                ? '长期有效'
                : getAttachmentInfo('LRC')?.certificateEndTime
            }}</span>
          </span>
        </div>
      </div>
    </div>
    <div class="module">
      <h5 class="module-title">公司银行账户信息</h5>
      <div class="module-descriptions">
        <div class="descriptions-item">
          <span class="label text-number-6">开户行行号：</span>
          <span class="value">
            <span>{{ detailsData?.bankSerials }}</span>
          </span>
        </div>
        <div class="descriptions-item">
          <span class="label text-number-7">开户行：</span>
          <span class="value">
            <span>{{ detailsData?.bankName }}</span>
          </span>
        </div>
        <div class="descriptions-item">
          <span class="label text-number-6">银行账户账号：</span>
          <span class="value">
            <span>{{ detailsData?.bankAccount }}</span>
          </span>
        </div>
        <div class="descriptions-item">
          <span class="label text-number-7">银行账户账户名：</span>
          <span class="value">
            <span>{{ detailsData?.bankAccountName }}</span>
          </span>
        </div>
      </div>
    </div>
    <div class="module">
      <h5 class="module-title">
        统一支付平台操作人员
        <span v-if="detailsData?.opMode === 2" class="title-desc"
          >多人操作模式</span
        >
      </h5>
      <template v-for="(item, index) in userData">
        <h6 :key="index + 'title'" class="module-title small-module-title">
          {{ item.title }}
        </h6>
        <div :key="index + ' descriptions'" class="module-descriptions">
          <div class="descriptions-item">
            <span class="label text-number-5">姓名：</span>
            <span class="value">
              <span>{{ item.realName }}</span>
            </span>
          </div>
          <div class="descriptions-item">
            <span class="label text-number-14">手机号码：</span>
            <span class="value">
              <span>{{ item.mobile }}</span>
            </span>
          </div>
          <div class="descriptions-item">
            <span class="label text-number-5">证件类型：</span>
            <span class="value">
              <span>{{ getCertificateTypeDesc(item.certificateType) }}</span>
            </span>
          </div>
          <div class="descriptions-item">
            <span class="label text-number-14">证件号码：</span>
            <span class="value">
              <span>{{
                getAttachmentInfo('UC', item.settleAccountUserAttachTempList)
                  ?.certificateNo
              }}</span>
            </span>
          </div>
          <div class="descriptions-item">
            <span class="label text-number-5">邮箱地址：</span>
            <span class="value">
              <span>{{ item.email }}</span>
            </span>
          </div>
          <!--          <div class="descriptions-item">-->
          <!--            <span class="label">证件有效期：</span>-->
          <!--            <span class="value">-->
          <!--              <span>{{-->
          <!--                getAttachmentInfo('UC', item.settleAccountAttachTempList)-->
          <!--                  ?.certificateLongValid === 1-->
          <!--                  ? '长期有效'-->
          <!--                  : getAttachmentInfo('UC', item.settleAccountAttachTempList)-->
          <!--                      ?.certificateValidityEnd-->
          <!--              }}</span>-->
          <!--            </span>-->
          <!--          </div>-->
          <div class="descriptions-item">
            <span class="label text-number-14">证件复印件：</span>
            <span class="value">
              <el-button
                type="text"
                size="small"
                @click="previewFile('UC', item.settleAccountUserAttachTempList)"
                >预览</el-button
              >
            </span>
          </div>
          <div class="descriptions-item">
            <span class="label">{{ item.title }}个人信息处理告知同意书：</span>
            <span class="value">
              <el-button
                type="text"
                size="small"
                @click="
                  previewFile('PPN', item.settleAccountUserAttachTempList)
                "
                >预览</el-button
              >
            </span>
          </div>
        </div>
        <div v-if="item.showSplitline" :key="index" class="module-line"></div>
      </template>
    </div>
    <div class="module">
      <h5 class="module-title">Ukey收件人信息</h5>
      <div class="module-descriptions">
        <div class="descriptions-item">
          <span class="label">收件人姓名：</span>
          <span class="value">
            <span>{{ ukeyData?.realName }}</span>
          </span>
        </div>
        <div class="descriptions-item">
          <span class="label text-number-14">收件人联系电话：</span>
          <span class="value">
            <span>{{ ukeyData?.mobile }}</span>
          </span>
        </div>
        <div class="descriptions-item">
          <span class="label">收件人公司：</span>
          <span class="value">
            <span>{{ ukeyData?.receiverCompanyName }}</span>
          </span>
        </div>
        <div class="descriptions-item">
          <span class="label text-number-14">收件人地址：</span>
          <span class="value">
            <span
              >{{ ukeyData?.province }}{{ ukeyData?.city
              }}{{ ukeyData?.district }}{{ ukeyData?.address }}</span
            >
          </span>
        </div>
      </div>
    </div>
    <viewer-image
      ref="viewer"
      :preview-src-list="[dialogPicUrl]"
    ></viewer-image>
  </div>
</template>

<script>
import Api from '@/modules/projectA/api/paymentAccount/index';
import viewerImage from '../components/viewerImage';
import { certificateTypeList } from '../constant';

export default {
  name: 'PaymentAccountDetail',
  components: { viewerImage },
  data() {
    return {
      loading: false,
      detailsData: {},
      ukeyData: {}, // ukey收件人信息
      userData: [], // 公司银行账户操作人信息
      // 法人证件类型
      certificateTypeList,
      dialogPicUrl: '',
    };
  },
  methods: {
    async initData(tempId) {
      if (!tempId) {
        return;
      }
      this.loading = true;
      const res = await Api.getEpaySettleAccountApplyInfo({
        tempId,
      }).finally(() => {
        this.loading = false;
      });
      if (res.code === '200') {
        this.detailsData = res.data;
        this.ukeyData = res.data?.settleAccountUkeyTemp;
        this.userData = res.data?.settleAccountUserTempList?.map((item) => {
          if (item.role === 'F002' || item.role === 'F002,F003') {
            item.title = res.data?.opMode === 2 ? '经办员' : '操作员';
            item.showSplitline =
              res.data?.opMode === 2 &&
              res.data?.settleAccountUserTempList.length === 2;
          }
          if (item.role === 'F003') {
            item.title = '审核员';
            item.showSplitline = false;
          }
          return item;
        });
      }
    },
    // 预览
    previewFile(type, list) {
      const fileObj = this.getAttachmentInfo(type, list);
      if (fileObj?.attachPath) {
        Api.getPayCenterFile({ filePath: fileObj?.attachPath }).then((res) => {
          if (res.code === '200') {
            this.dialogPicUrl = res.data;
            this.$refs.viewer.show();
          }
        });
      } else {
        this.$message.info('暂无可预览文件');
      }
    },
    // 获取证件类型描述
    getCertificateTypeDesc(certificateType) {
      return this.certificateTypeList?.find(
        (item) => item.itemCode === certificateType
      )?.itemDisp;
    },
    // 获取附件信息
    getAttachmentInfo(type, list) {
      const sourceData = list ?? this.detailsData?.settleAccountAttachTempList;
      return sourceData?.find((item) => item.attachType === type);
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  background: #eee;
  .module {
    margin: 20px 0;
    padding: 20px;
    display: flex;
    flex-direction: column;
    box-shadow: 0px 0px 10px 0px #0000001a;
    background: #ffffff;
    .module-title {
      color: #333;
      font-family: Source Han Sans CN;
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: 16px; /* 100% */
      margin-bottom: 8px;
      .title-desc {
        display: inline-flex;
        padding: 2px 4px;
        align-items: center;
        border-radius: 3px;
        background: #2587ff;
        color: #fff;
        font-family: Source Han Sans CN;
        font-size: 10px;
        font-weight: 400;
        line-height: 10px; /* 100% */
        margin-left: 10px;
      }
    }
    .small-module-title {
      font-size: 14px;
      margin-top: 12px;
      margin-bottom: 0;
    }
    .module-tips {
      padding: 15px 0px 15px 10px;
      background: #f4f7ff;
      color: #666;
      font-family: Source Han Sans CN;
      font-size: 14px;
      font-style: normal;
      font-weight: 350;
    }
    .module-descriptions {
      display: flex;
      flex-wrap: wrap;
      .descriptions-item:nth-child(odd) {
        width: 45%;
      }
      .descriptions-item:nth-child(even) {
        width: 55%;
      }
      .descriptions-item {
        //width: 50%;
        display: flex;
        margin-top: 20px;
        color: #333;
        font-family: Source Han Sans CN;
        font-size: 14px;
        font-style: normal;
        font-weight: 350;
        line-height: 14px; /* 100% */
        .label {
          display: inline-block;
          white-space: nowrap;
          text-align: right;
        }
        .value {
          flex: 1;
          span {
            margin-right: 10px;
          }
          ::v-deep .el-button {
            padding: 0;
            color: #0064c8;
            font-family: Source Han Sans CN;
            font-size: 14px;
            font-weight: 350;
          }
        }
        .text-number-3 {
          width: 56px;
        }
        .text-number-4 {
          width: 70px;
        }
        .text-number-5 {
          width: 84px;
        }
        .text-number-6 {
          width: 98px;
        }
        .text-number-7 {
          width: 112px;
        }
        .text-number-14 {
          width: 210px;
        }
      }
    }
    .module-line {
      border-top: 1px dotted #c5c5c5;
      margin-top: 20px;
    }
  }
}
</style>
